import { Box } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkTable from "../../components/atoms/TkTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import { headList, symbolHeadList } from "./parts";
import TkMemo from "../../components/molecules/TkMemo";
import { httpIAPI_APP016, httpIAPI_FAC021 } from "./api/request";
import TkDownloadLink from "../../components/atoms/TkDownloadLink";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import { IAPI_APP016_Request, IAPI_FAC021_Response } from "../../type/apiType";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import {
  CommonOrCommonRetirementFlug,
  FormClassApply,
  formClassFacility,
  FormKbn,
  InquiryCode,
  Status,
} from "../../assets/data/Constants";
import "./_style.scss";
import TkButton from "../../components/atoms/TkButton";
import {
  changeAmountFormat,
  isStatusAfterApproval,
} from "../../utils/useTools";
import { TkGetCode } from "../../utils/TkGetCode";

/**
 * SCRW050009_部分解除　入力内容確認
 */
const SCRW050009: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessStete } =
    useContext(BusinessContext);
  const [bodyList, setBodyList] = useState<any[]>([]);
  const [symbolBodyList, setSymbolBodyList] = useState<any[]>([]);
  const [memoBodyList, setMemoBodyList] = useState<any[]>([]);
  const [apiData, setApiData] = useState<IAPI_FAC021_Response>({});
  const [open, setOpen] = useState(false);
  const [memoData, setMemoData] = useState<any>({ memo: "", checked: false });

  const userType = state.authInfo?.userType;
  const contractorDisplay =
    (businessState.common?.contractorNo ?? "") +
    ":" +
    (businessState.common?.contractorName ?? "");

  const handleInit = async () => {
    try {
      const res = await httpIAPI_FAC021({
        applyId: location.state?.applyId
          ? location.state?.applyId
          : businessState.job_16?.applyId,
      });

      if (res.resultCd === "I0000") {
        setApiData(res);
        setMemoBodyList(formatMemoData(res.statusList));
        const reportAgreement = res.formList?.filter((item) => {
          return (
            item.formClass === formClassFacility["部分解除同意書"] &&
            item.formKbn === FormKbn["施設書類"]
          );
        });
        const reportNotIncludeAgreement = res.formList?.filter((item) => {
          return (
            item.formClass === FormClassApply["退職手当共済契約部分解除通知書"]
          );
        });

        setBodyList(formatData(res, reportAgreement));
        setSymbolBodyList(formatLedgerData(res, reportNotIncludeAgreement));

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const ReportDownloadLink = ({ formList }: any) => {
    if (
      formList.formClass === FormClassApply["退職手当共済契約部分解除通知書"]
    ) {
      return (
        <TkDownloadLink
          base64filedata={formList.fileBase64}
          dataname={
            TkGetCode(FormClassApply, "EXP0601017") +
            "・" +
            TkGetCode(FormClassApply, "EXP0601018")
          }
          downloadBase64={true}
        />
      );
    } else {
      return <></>;
    }
  };

  // 確認ボタン押下時のイベント
  const handleAgree = (facilityNo: string) => {
    if (!facilityNo) return;
    setBusinessStete({
      ...businessState,
      job_16: {
        ...businessState.job_16,
        applyId: location.state?.applyId
          ? location.state?.applyId
          : businessState.job_16?.applyId,
      },
    });

    navigate("/SCRC050115", { state: { facilityNo: facilityNo } });
  };

  const formatData = (
    data: IAPI_FAC021_Response,
    reportList: IAPI_FAC021_Response["formList"]
  ) => {
    return (
      data?.targetFacilityList?.map((item) => {
        const report = reportList?.find((itemTimi) => {
          return itemTimi.facilityNo === item.facilityNo;
        });

        return [
          {
            children: (item.facilityNo ?? "") + ":" + (item.facilityName ?? ""),
          },
          {
            children: item.facilityKind,
          },
          {
            children: item.facilityKbn,
          },
          {
            children: item.cancelDate,
            align: "center",
          },
          {
            children: changeAmountFormat(item.cancelMaStaffNum ?? 0) + "人",
            align: "right",
          },
          {
            children: report ? (
              <TkDownloadLink
                base64filedata={report?.fileBase64 ?? ""}
                dataname={report?.fileName ?? ""}
                downloadBase64={true}
              />
            ) : null,
          },
          {
            children: item.cancelReason,
          },
          {
            children: (
              <TkButton
                data-testid="tkDialogOkButtonForTest"
                onClick={() => handleAgree(item.facilityNo || "")}
                disabled={item.withinThreeMonthsRetireeNum === 0}
              >
                確認
              </TkButton>
            ),
            align: "center",
          },
        ];
      }) || []
    );
  };

  const formatLedgerData = (
    data: IAPI_FAC021_Response,
    reportList: IAPI_FAC021_Response["formList"]
  ) => {
    let showLine = isStatusAfterApproval(data.latestApplyStatus);
    return (
      reportList?.map((item) => [
        {
          children: <ReportDownloadLink formList={item} />,
          width: "40%",
        },
        {
          children: showLine && data.symbolNo,
        },
        {
          children: showLine && data.decisionDate,
        },
      ]) ?? []
    );
  };

  const formatMemoData = (statusList: IAPI_FAC021_Response["statusList"]) => {
    return (
      statusList?.map((item) => [
        {
          children: item.managerName,
        },
        {
          children: item.process,
        },
        {
          children: item.createDate,
          align: "center",
        },
        {
          children: item.processComment,
        },
      ]) ?? []
    );
  };

  // 初期表示
  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ボタンイベント
  const btnEvent = (btnName: any, registrationObj?: any) => {
    let num = "";
    const btnMap: { [key: string]: string } = {
      契約者に差戻し: "5",
      受理: "2",
      承認: "openDialog",
      承認確認: "3",
      担当者に差戻し: "8",
      課長代理確認: "14",
      上長承認: "6",
      郵送: "11",
    };

    num = btnMap[btnName] || "";
    if (!num) return;

    if (num === "openDialog") {
      setOpen(true);
      return;
    }
    let param: IAPI_APP016_Request = {
      applyId: location.state?.applyId
        ? location.state?.applyId
        : businessState.job_16?.applyId,
      applyEvent: num,
      contractorNo: businessState.common?.contractorNo,
      screenId: "SCRW050009",
      reason: memoData.memo,
    };

    if (memoData.checked) {
      param = { ...param, inquiryCode: InquiryCode["施設"] };
    }
    if (num === "3") {
      const retirementText = Object.entries(CommonOrCommonRetirementFlug)
        .map((key) => {
          return { key: key[0], value: key[1] };
        })
        .find((item) => item.value === registrationObj.symbolNumberType)?.key;

      param = {
        ...param,
        symbolNo:
          (retirementText ?? "") +
          "第" +
          (registrationObj.symbolNumber ?? "") +
          "号",
        decisionDate: registrationObj.settlementDate,
      };
    }
    applicationStatusUpdate(param);
  };

  // 申請状況更新
  const applicationStatusUpdate = async (param: IAPI_APP016_Request) => {
    try {
      const res = await httpIAPI_APP016(param);

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        return;
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // メモ変更
  const memoChange = (e: any) => {
    if (e.target.type === "input") {
      setMemoData({ ...memoData, memo: e.target.value });
    } else {
      setMemoData({ ...memoData, checked: e.target.value });
    }
  };

  // 承認確認ダイアログ
  const handleregistrationObjDialog = (registrationObj: any) => {
    setOpen(false);
    btnEvent("承認確認", registrationObj);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box className="SCRW050009" data-testid="SCRW050009test">
      {apiData && (
        <TkKikoStepper
          applicationFlowType="TYPE2"
          businessType="JOB-16"
          corporateApplicationClassification={apiData.corpApplyKbn as any}
          applicationStatus={apiData.latestApplyStatus as Status}
        />
      )}
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLW050009_01}</TkInfoManual>
      {userType === authorityUserType.userTypeNumber.KIKO && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={contractorDisplay}
        />
      )}

      <TkTable headList={headList} bodyList={bodyList} />

      <TkMemo
        bodyList={memoBodyList}
        onChange={memoChange}
        disabledCheckBox={false}
      />

      {symbolBodyList.length > 0 && (
        <TkTableWithNoLine
          headList={symbolHeadList}
          bodyList={symbolBodyList}
        />
      )}

      <Box className="btnGroup">
        <TkBackButton mr />
        {apiData.latestApplyStatus && (
          <TkViewButtonJudgement
            flowType="TYPE2"
            Status={apiData.latestApplyStatus as Status}
            onClick={btnEvent}
            data-testid="TkViewButtonJudgement"
          />
        )}
      </Box>
      <TkApprovalDateSymbolNumberRegistrationDialog
        open={open}
        onClose={handleClose}
        onSuccess={handleregistrationObjDialog}
      />
    </Box>
  );
};

export default SCRW050009;
